import HelpIcon from "@mui/icons-material/Help";
import {
  Alert,
  Box,
  CircularProgress,
  createTheme,
  LinearProgress,
  Snackbar,
  Stack,
  Tooltip,
} from "@mui/material";
import MuiPagination from "@mui/material/Pagination";
import {
  DataGridPremium,
  GridCsvExportMenuItem,
  GridExcelExportMenuItem,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  gridFilteredSortedRowIdsSelector,
  useGridApiRef,
  gridPageCountSelector,
  useGridSelector
} from "@mui/x-data-grid-premium";
import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FieldNames from "../../../../defaults/FieldNames.json";
import GridDefinitions from "../../../../defaults/GridDefinitions.json";
import ErrorService from "../../../../services/ErrorService";
import TargetAccomplishmentService from "../../../../services/TargetAccomplishmentService";
import { addCommas, percentFormat } from "../../../../utils/FormatHelper";
import Events from "../../../../defaults/Events";
import { useCustomEventListener } from "react-custom-events";
import InFormGenericModal from "../../../InFormGenericModal";
import { useIFPRSGlobalContext } from "../../../../IFPRSGlobalContext";
import {ThemeProvider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ColorConstants from "../../../../defaults/ColorConstants";
import UserHelperService from "../../../../services/UserHelperService";
import { DepartureBoard } from "@mui/icons-material";
import {useGridApiContext} from "@mui/x-data-grid";
import {formatDateForDisplay} from "../../../../utils/DateHelper";


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  const finalWidth = width - 20;
  return {
    finalWidth,
    height
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


export default function TargetManagementFuels({
  setColumnVisibilityModel,
  setShowMap,
  currentUserInfo,
  classOptionSelection,
  columnVisibilityModel,
  setGraphRows,
  setLimitedGraphRows,
  fundingDepartmentSelection,
  fundingAgencySelection,
  fundingRegionSelection,
  fundingUnitSelection,
  fundingSubUnitSelection,
  fundingTribeSelection,
  entityTypeSelection,
  fiscalYearSelection,
  userInfo,
  setExistingLockDate,
  generateProgramOfWorkCSV,
  gridRadioValue
}) {
  const useStyles = makeStyles({
    underline: {
      "&&&:before": {
        borderBottom: "2px solid red",
      },
      "&&:after": {
        borderBottom: "2px solid red",
      },
    },
    condensedFormControl: {
      margin: "5px 15px 5px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControl: {
      margin: "10px 15px 10px 15px",
      minWidth: 120,
      width: "90%",
    },
    formControlHeader: {
      margin: "0px 15px 0px 15px",
      minWidth: 120,
      width: "90%",
    },
    snackBarStyle: {
      top: "120px !important",
    },
  });
   const theme = createTheme({
      overrides: {
        palette: {
          red: {
            main: "#FF0000",
            light: "#FF0000",
            dark: "#FF0000",
            contrastText: "#242105",
          },
        },
        MuiPaper: {
          root: {
            backgroundColor: "green",
          },
        },
        MuiOutlinedInput: {
          root: {
            "& $notchedOutline": {
              //initial border
              borderColor: ColorConstants.BlueAlien,
            },
            "&:hover $notchedOutline": {
              //border on hover
              borderColor: ColorConstants.BlueAlien,
              border: "2px solid",
            },
            "&$focused $notchedOutline": {
              //border on focus
              borderColor: ColorConstants.BlueAlien,
              border: "2px solid",
            },
          },
        },
      },
    });
  const classes = useStyles();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isFailure, setIsFailure] = useState(false);
  
  const config = useSelector((state) => state.configuration.config);
  const apiRef = useGridApiRef();
  const rootServiceUrl = useSelector(
    (state) => state.configuration.rootServiceUrl
  );
  const viewRootServiceUrl = useSelector(
    (state) => state.configuration.viewRootServiceUrl
  );
  const nifcToken = useSelector((state) => state.configuration.nifcToken);
  const [gridColumns, setGridColumns] = useState([]);
  const [gridRows, setGridRows] = useState([]);
  const [maxCountPerGraph] = useState(25);
  const [isGridLoading, setIsGridLoading] = useState(false);
  const defaultTargetManagementGridColDefinitions = [
    GridDefinitions.LockedTargetManagementGrid.name,
    GridDefinitions.LockedTargetManagementGrid.targetAcres,
    GridDefinitions.LockedTargetManagementGrid.targetPercentComplete,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.allPercentComplete,
    GridDefinitions.LockedTargetManagementGrid.actualHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.allApprovedNonHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.actualNonHFRAcres
  ];
  const fundingTargetManagementGridColDefinitions = defaultTargetManagementGridColDefinitions; // TODO: To be worked in story FUELS-1431
  const carryoverTargetManagementGridColDefinitions = [
    GridDefinitions.LockedTargetManagementGrid.name,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRNonCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.actualHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.actualHFRCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.actualHFRNonCarryoverAcres
  ];
  const allTargetManagementGridColDefinitions = [
    GridDefinitions.LockedTargetManagementGrid.name,
    GridDefinitions.LockedTargetManagementGrid.targetAcres,
    GridDefinitions.LockedTargetManagementGrid.targetPercentComplete,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.allApprovedHFRNonCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.allPercentComplete,
    GridDefinitions.LockedTargetManagementGrid.actualHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.actualHFRCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.actualHFRNonCarryoverAcres,
    GridDefinitions.LockedTargetManagementGrid.allApprovedNonHFRAcres,
    GridDefinitions.LockedTargetManagementGrid.actualNonHFRAcres,
  ];

  const [acreCounts, setAcreCounts] = useState({
    AcresCount: 100,
  });

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const highestCount = gridRows ? Math.max(gridRows.length) : 0;
  const totalCount = gridRows ? (gridRows.length) : 0;
  const estPageCount = highestCount > 0 ? Math.ceil(highestCount / paginationModel.pageSize) : 1;
  const rowCountRef = React.useRef(highestCount || 0);
  const rowCount = React.useMemo(() => {
    if (highestCount !== undefined) {
      rowCountRef.current = highestCount;
    }
    return rowCountRef.current;
  }, [highestCount]);
  const currentMaxFrom = ((paginationModel.page) * paginationModel.pageSize);
  const currentMaxTo = ((paginationModel.page+1) * paginationModel.pageSize);
  const fromCount = acreCounts.AcresCount < currentMaxFrom ? acreCounts.AcresCount : currentMaxFrom;
  const toCount = gridRows.length < 25 ? currentMaxFrom + gridRows.length : currentMaxTo;
  const rowHelpText = `The system will display up to 100 items per page. This page is displaying: \n  ${acreCounts.AcresCount} Acre Lines`
  const [isTreatment, setIsTreatment] = useState(true);
  const [openProgramOfWorkDialog, setOpenProgramOfWorkDialog] = useState(false);
  const { setShowGlobalLoader} = useIFPRSGlobalContext();

  // Formatted budget values
  const [selectionModel, setSelectionModel] = useState({ids: new Set(), type: 'include'});
  const [aggregationModel, setAggregationModel] = useState({
    TotalBudget: "sum",
    RegularBudget: "sum",
    BILBudget: "sum",
    DisasterReliefBudget: "sum",
  });

  useCustomEventListener(Events.LockProgramOfWork, () => {
    setOpenProgramOfWorkDialog(true);
  });

  useEffect(() => {
    setShowMap(false);
  }, [setShowMap]);

  useEffect(() => {
    establishGridColumns();
  }, [gridRadioValue]);

  const lockProgramOfWork = async () => {
    try
    {
      setShowGlobalLoader(true);

      if(userInfo?.[FieldNames.userFields.isProgramOfWorkAdmin])
      {
        const allUnitCombinations = await UserHelperService.getAllUnitTableCombinations();
        const tribeCombinations = allUnitCombinations.filter(x => x && x[FieldNames.units.tribeFullName]);
        const subUnitCombinations = allUnitCombinations.filter(x => x && x[FieldNames.units.subUnit]);
        const unitCombinations = allUnitCombinations.filter(x => x && x[FieldNames.units.unit] && (!x[FieldNames.units.tribeFullName] && !x[FieldNames.units.subUnit]));
        const regionBreakdowns = allUnitCombinations.map(x => {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: x[FieldNames.units.region],
            Unit: "",
            SubUnit: "",
            Tribe: ""
          }
        })
        let distinctRegionBreakdowns = [...new Set(regionBreakdowns.map(x => JSON.stringify(x)))].map(x => JSON.parse(x));
        const regionCombinations = distinctRegionBreakdowns.filter(x => x && x[FieldNames.units.region]);
        const agencyBreakdowns = unitCombinations.map(x => {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: "",
            Unit: "",
            SubUnit: "",
            Tribe: ""
          }
        })
        let distinctAgencyBreakdowns = [...new Set(agencyBreakdowns.map(x => JSON.stringify(x)))].map(x => JSON.parse(x));
        const agencyCombinations = distinctAgencyBreakdowns.filter(x => x && x[FieldNames.units.agency]);
        const departmentCombinations = [...new Set(allUnitCombinations.filter(x => x && x[FieldNames.units.department]).map(x => x[FieldNames.units.department]))].map(x => {return {Department: x }});

        let allTribeObjects = tribeCombinations.map(x => 
        {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: x[FieldNames.units.region],
            Unit: x[FieldNames.units.unit],
            SubUnit: "",
            Tribe: x[FieldNames.units.tribeFullName]
          }
        });
        let allSubUnitObjects = subUnitCombinations.map(x => 
        {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: x[FieldNames.units.region],
            Unit: x[FieldNames.units.unit],
            SubUnit: x[FieldNames.units.subUnit],
            Tribe: ""
          }
        });
        let allUnitObjects = unitCombinations.map(x => 
        {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: x[FieldNames.units.region],
            Unit: x[FieldNames.units.unit],
            SubUnit: "",
            Tribe: ""
          }
        });
        let allRegionObjects = regionCombinations.map(x => 
        {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: x[FieldNames.units.region],
            Unit: "",
            SubUnit: "",
            Tribe: ""
          }
        });
        let allAgencyObjects = agencyCombinations.map(x => 
        {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: "",
            Unit: "",
            SubUnit: "",
            Tribe: ""
          }
        });
        let allDepartmentObjects = departmentCombinations.map(x => 
        {
          return {
            Department: x[FieldNames.units.department],
            Agency: "",
            Region: "",
            Unit: "",
            SubUnit: "",
            Tribe: ""
          }
        });

        const allTreatments = await TargetAccomplishmentService.getAllTreatmentsForProgramOfWorkLockByFY(fiscalYearSelection);

        let allTalliedEntries = [];
        let allTalliedDepartments = allDepartmentObjects.map(unitObject => {
          let matchingTreatments = allTreatments.filter(x => x[FieldNames.featureFields.fundingDepartment] === unitObject[FieldNames.units.department]);
          let talliedObjects = getTargetSummedValues(matchingTreatments, unitObject);
          return talliedObjects;
        }); 
        let allTalliedAgencies = allAgencyObjects.map(unitObject => {
          let matchingTreatments = allTreatments.filter(x => 
            x[FieldNames.featureFields.fundingDepartment] === unitObject[FieldNames.units.department] && 
            x[FieldNames.featureFields.fundingAgency] === unitObject[FieldNames.units.agency]
          );
          let talliedObjects = getTargetSummedValues(matchingTreatments, unitObject);
          return talliedObjects;
        }); 
        let allTalliedRegions = allRegionObjects.map(unitObject => {
          let matchingTreatments = allTreatments.filter(x => 
            x[FieldNames.featureFields.fundingDepartment] === unitObject[FieldNames.units.department] && 
            x[FieldNames.featureFields.fundingAgency] === unitObject[FieldNames.units.agency] &&
            x[FieldNames.featureFields.fundingRegion] === unitObject[FieldNames.units.region]
          );
          let talliedObjects = getTargetSummedValues(matchingTreatments, unitObject);
          return talliedObjects;
        }); 
        let allTalliedUnits = allUnitObjects.map(unitObject => {
          let matchingTreatments = allTreatments.filter(x => 
            x[FieldNames.featureFields.fundingDepartment] === unitObject[FieldNames.units.department] && 
            x[FieldNames.featureFields.fundingAgency] === unitObject[FieldNames.units.agency] &&
            x[FieldNames.featureFields.fundingRegion] === unitObject[FieldNames.units.region] &&
            x[FieldNames.featureFields.fundingUnit] === unitObject[FieldNames.units.unit]
          );
          let talliedObjects = getTargetSummedValues(matchingTreatments, unitObject);
          return talliedObjects;
        });
        let allTalliedSubUnits = allSubUnitObjects.map(unitObject => {
          let matchingTreatments = allTreatments.filter(x => 
            x[FieldNames.featureFields.fundingDepartment] === unitObject[FieldNames.units.department] && 
            x[FieldNames.featureFields.fundingAgency] === unitObject[FieldNames.units.agency] &&
            x[FieldNames.featureFields.fundingRegion] === unitObject[FieldNames.units.region] &&
            x[FieldNames.featureFields.fundingUnit] === unitObject[FieldNames.units.unit] &&
            x[FieldNames.featureFields.fundingSubUnit] === unitObject[FieldNames.units.subUnit]
          );
          let talliedObjects = getTargetSummedValues(matchingTreatments, unitObject);
          return talliedObjects;
        });
        let allTalliedTribes = allTribeObjects.map(unitObject => {
          let matchingTreatments = allTreatments.filter(x => 
            x[FieldNames.featureFields.fundingDepartment] === unitObject[FieldNames.units.department] && 
            x[FieldNames.featureFields.fundingAgency] === unitObject[FieldNames.units.agency] &&
            x[FieldNames.featureFields.fundingRegion] === unitObject[FieldNames.units.region] &&
            x[FieldNames.featureFields.fundingUnit] === unitObject[FieldNames.units.unit] &&
            x[FieldNames.featureFields.fundingTribe] === unitObject[FieldNames.units.tribe]
          );
          let talliedObjects = getTargetSummedValues(matchingTreatments, unitObject);
          return talliedObjects;
        });
        
        allTalliedEntries = [...allTalliedDepartments, ...allTalliedAgencies, ...allTalliedRegions,
                             ...allTalliedUnits, ...allTalliedSubUnits, ...allTalliedTribes];

        let powObjects = allTalliedEntries.map(x => {
          return {
            Department: x[FieldNames.units.department],
            Agency: x[FieldNames.units.agency],
            Region: x[FieldNames.units.region],
            Unit: x[FieldNames.units.unit],
            SubUnit: x[FieldNames.units.subUnit],
            Tribe: x.Tribe,
            FiscalYear: fiscalYearSelection.FiscalYear,
            Class: FieldNames.targetAccomplishmentClasses.treatment,
            POWTargetAcres: x.POWTargetAcres,
            CarryoverAcres: x.CarryoverAcres,
            NonCarryoverAcres: x.NonCarryoverAcres,
            FMRegAcres: x.FMRegAcres,
            FMDisasterReliefAcres: x.FMDisasterReliefAcres,
            BILAcres: x.BILAcres,
            CreatedBy: userInfo[FieldNames.userFields.nifcUsername],
            CreatedOnDate: formatDateForDisplay(Date.now())
          }
        })

        let preExistingData = await TargetAccomplishmentService.getAllLockedEntriesForFY(fiscalYearSelection);

        let combinedPowObjects = powObjects.map(x => {
          let existingPowObject = preExistingData.find(existingObj => 
            ((existingObj.Department === x.Department)
            && (existingObj.Agency === x.Agency)
            && (existingObj.Region === x.Region)
            && (existingObj.Unit === x.Unit)
            && (existingObj.SubUnit === x.SubUnit)
            && (existingObj.Tribe === x.Tribe || (!existingObj.Tribe && !x.Tribe)))
          )
          if(!existingPowObject?.[FieldNames.featureFields.objectID])
          {
            return x;
          }
          let combinedObj = {
            ...x,
            OBJECTID: existingPowObject?.[FieldNames.featureFields.objectID]
          }
          return combinedObj;
        })
        let existingPowObjects = combinedPowObjects.filter(x => x[FieldNames.featureFields.objectID]);
        let newPowObjects = combinedPowObjects.filter(x => !x[FieldNames.featureFields.objectID]);
        
        let addResp = TargetAccomplishmentService.addProgramOfWorkRecords(newPowObjects);
        let updateResp = TargetAccomplishmentService.updateMultiplePows(existingPowObjects);
        let respValues = await Promise.all([addResp, updateResp]);
        let combinedResp = [].concat(...respValues);

        setIsFailure(false);
        setSnackbarOpen(true);
        setSnackbarMessage(`The POW for FY${fiscalYearSelection?.FiscalYear} has been locked`);

        generateProgramOfWorkCSV(false);
      }
    }
    catch(e)
    {
      setIsFailure(true);
      setSnackbarOpen(true)
      setSnackbarMessage("There was an issue generating the APOW");
      ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], e);
    }
    finally
    {
      setShowGlobalLoader(false);
      if(entityTypeSelection === FieldNames.datasets.fuels){
        getLiveRows();
      }
    }
  }

  const getTargetSummedValues = (matchingTreatments, unitObject) => {
    let summedPOWTargetAcres = matchingTreatments.map(x => x.TargetAcres).reduce((acc, current) => {
      return acc + current;
    }, 0);
    let summedCarryoverAcres = matchingTreatments.map(x => x.CarryoverAcres).reduce((acc, current) => {
      return acc + current;
    }, 0);
    let summedNonCarryoverAcres = matchingTreatments.map(x => x.NonCarryoverAcres).reduce((acc, current) => {
      return acc + current;
    }, 0);
    let summedFMRegAcres = matchingTreatments.map(x => x.FMRegAcres).reduce((acc, current) => {
      return acc + current;
    }, 0);
    let summedFMDisasterReliefAcres = matchingTreatments.map(x => x.FMDisasterReliefAcres).reduce((acc, current) => {
      return acc + current;
    }, 0);
    let summedBILAcres = matchingTreatments.map(x => x.BILAcres).reduce((acc, current) => {
      return acc + current;
    }, 0);

    return {
      Department: unitObject[FieldNames.units.department],
      Agency: unitObject[FieldNames.units.agency],
      Region: unitObject[FieldNames.units.region],
      Unit: unitObject[FieldNames.units.unit],
      SubUnit: unitObject[FieldNames.units.subUnit],
      Tribe: unitObject.Tribe,
      FiscalYear: fiscalYearSelection.FiscalYear,
      Class: FieldNames.targetAccomplishmentClasses.treatment,
      POWTargetAcres: summedPOWTargetAcres,
      CarryoverAcres: summedCarryoverAcres,
      NonCarryoverAcres: summedNonCarryoverAcres,
      FMRegAcres: summedFMRegAcres,
      FMDisasterReliefAcres: summedFMDisasterReliefAcres,
      BILAcres: summedBILAcres,
    }
  }

  //
  // Manage Grid Rows
  //

  useEffect(() => {
    if (
      !config ||
      !viewRootServiceUrl ||
      !fiscalYearSelection ||
      (!fundingDepartmentSelection &&
        !fundingAgencySelection &&
        !fundingRegionSelection &&
        !fundingUnitSelection && 
        !fundingSubUnitSelection &&
        !fundingTribeSelection && 
        !entityTypeSelection
      )
    ) {
      return;
    }

    establishGridColumns();
    setIsGridLoading(true);
    
    if(entityTypeSelection === FieldNames.datasets.fuels){
      //Need to query the locked table to see if values exist for the selected fiscal year
      //If they do, match them up with the correct values from the unlocked values
      setGridRows([]);
      getLiveRows();
      
    } 
  }, [
    config,
    rootServiceUrl,
    viewRootServiceUrl,
    fiscalYearSelection,
    fundingDepartmentSelection,
    fundingAgencySelection,
    fundingRegionSelection,
    fundingUnitSelection,
    fundingTribeSelection,
    fundingSubUnitSelection,
    currentUserInfo,
    isTreatment,
    nifcToken,
    entityTypeSelection
  ]);

  const getLiveRows = () => {
    let departmentExists = fundingDepartmentSelection && fundingDepartmentSelection[FieldNames.targetFields.filterDepartment];
    let agencyExists = fundingAgencySelection && fundingAgencySelection[FieldNames.targetFields.filterAgency];
    let regionExists = fundingRegionSelection && fundingRegionSelection[FieldNames.targetFields.filterRegion];
    let unitExists = fundingUnitSelection && fundingUnitSelection[FieldNames.targetFields.filterUnit];
    let subUnitExists = fundingSubUnitSelection && fundingSubUnitSelection[FieldNames.targetFields.filterSubUnit];
    let tribeExists = fundingTribeSelection && fundingTribeSelection["TribeFullName"];
    let tempSorted = [];
    TargetAccomplishmentService.getAllTargetEntriesFuels(
      viewRootServiceUrl,
      config,
      fiscalYearSelection,
      departmentExists,
      agencyExists,
      regionExists,
      unitExists,
      subUnitExists,
      tribeExists,
      entityTypeSelection,
      isTreatment
    ).then(async (resp) => {
      if (resp && resp.length > 0) {
        let existingNames = [];
        let finalRows = [];
        let index = 0;

        resp?.forEach((estItem) => {
          let level = "Department";
          if(!departmentExists){
            level = "Department";
          } else if(departmentExists && !agencyExists){
            level = "Agency";
          } else if (departmentExists && agencyExists && !regionExists) {
            level = "Region";
          } else if (departmentExists && agencyExists && regionExists && !unitExists
          ) { 
            level = "Unit";
          } else if (departmentExists && agencyExists && regionExists && unitExists && !subUnitExists && !tribeExists
          ) {
            level = "Unit";
          } else if (departmentExists && agencyExists && regionExists && unitExists && subUnitExists && !tribeExists
          ) {
            level = "SubUnit";
          } else if (departmentExists && agencyExists && regionExists && unitExists && !subUnitExists && tribeExists
          ) {
            level = "Tribe";
          }

          // lockedTargetFields?.filter(x => x[level]?.toLowerCase()?.trim() === estItem[FieldNames.targetFields.name]?.toLowerCase()?.trim());
          
          if(!existingNames.includes(estItem[FieldNames.lockedTargetFields.name]?.toLowerCase()?.trim())){
            const matchingNamedItems = resp.filter(x => x[FieldNames.targetFields.name]?.toLowerCase()?.trim() === estItem[FieldNames.targetFields.name]?.toLowerCase()?.trim());
            let allApprovedHFRAcres = estItem[FieldNames.lockedTargetFields.allApprovedHFRAcres] ? estItem[FieldNames.lockedTargetFields.allApprovedHFRAcres] : 0;
            let actualHFRAcres = estItem[FieldNames.lockedTargetFields.actualHFRAcres] ? estItem[FieldNames.lockedTargetFields.actualHFRAcres] : 0;
            let allApprovedNonHFRAcres = estItem[FieldNames.lockedTargetFields.allApprovedNonHFRAcres] ? estItem[FieldNames.lockedTargetFields.allApprovedNonHFRAcres] : 0;
            let actualNonHFRAcres = estItem[FieldNames.lockedTargetFields.actualNonHFRAcres] ? estItem[FieldNames.lockedTargetFields.actualNonHFRAcres] : 0;
            let bilAcres = estItem[FieldNames.lockedTargetFields.bilAcres] ? estItem[FieldNames.lockedTargetFields.bilAcres] : 0;
            let fmRegAcres = estItem[FieldNames.lockedTargetFields.fmRegAcres] ? estItem[FieldNames.lockedTargetFields.fmRegAcres] : 0;
            let fmDisasterAcres = estItem[FieldNames.lockedTargetFields.fmDisasterAcres] ? estItem[FieldNames.lockedTargetFields.fmDisasterAcres] : 0;
            let allApprovedHFRCarryoverAcres = estItem[FieldNames.lockedTargetFields.allApprovedHFRAcres] ? estItem[FieldNames.lockedTargetFields.allApprovedHFRAcres] : 0;
            let allApprovedHFRnonCarryoverAcres = estItem[FieldNames.lockedTargetFields.allApprovedHFRnonCarryoverAcres] ? estItem[FieldNames.lockedTargetFields.allApprovedHFRnonCarryoverAcres] : 0; 
            let actualHFRCarryoverAcres = estItem[FieldNames.lockedTargetFields.actualHFRCarryoverAcres] ? estItem[FieldNames.lockedTargetFields.actualHFRCarryoverAcres] : 0;
            let actualHFRnonCarryoverAcres = estItem[FieldNames.lockedTargetFields.actualHFRnonCarryoverAcres] ? estItem[FieldNames.lockedTargetFields.actualHFRnonCarryoverAcres] : 0; 
            if(matchingNamedItems?.length){
              //Add up all acre fields here
              allApprovedHFRAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.allApprovedHFRAcres];
              }, 0);
              allApprovedHFRCarryoverAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.allApprovedHFRCarryoverAcres];
              }, 0);
              allApprovedHFRnonCarryoverAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.allApprovedHFRnonCarryoverAcres];
              }, 0);
              actualHFRAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.actualHFRAcres];
              }, 0);
              actualHFRCarryoverAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.actualHFRCarryoverAcres];
              }, 0);
              actualHFRnonCarryoverAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.actualHFRnonCarryoverAcres];
              }, 0);
              allApprovedNonHFRAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.allApprovedNonHFRAcres];
              }, 0);
              actualNonHFRAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.actualNonHFRAcres];
              }, 0);
              bilAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.bilAcres];
              }, 0);
              fmRegAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.fmRegAcres];
              }, 0);
              fmDisasterAcres = matchingNamedItems.reduce((accumulator, currentValue) => {
                return accumulator + currentValue[FieldNames.lockedTargetFields.fmDisasterAcres];
              }, 0);
            }
            const obj = {
              ID: index,
              Name: estItem[FieldNames.lockedTargetFields.name],
              //TargetAcres is blank until locked - When locked this is a sum of all acres for the FY, exclude carryover and exclude contributed
              TargetAcres: null,
              //TargetPercentComplete is blank until locked, excludes carryover
              TargetPercentComplete: null,
              //AllApprovedHFRAcres is a live number and only departmentally approved, not contributed
              AllApprovedHFRAcres: allApprovedHFRAcres,
              AllApprovedHFRCarryoverAcres: allApprovedHFRCarryoverAcres,
              AllApprovedHFRNonCarryoverAcres: allApprovedHFRnonCarryoverAcres,
              //AllPercentComplete is a percentage of acres: ActualHFRAcres/AllApprovedHFRAcres
              AllPercentComplete: (actualHFRAcres && allApprovedHFRAcres) ? (Math.round((actualHFRAcres / allApprovedHFRAcres) * 100)) : 0,
              //ActualHFRAcres is a live number and only non-contributed acres and ones that have a completion date
              ActualHFRAcres: actualHFRAcres,
              ActualHFRCarryoverAcres: actualHFRCarryoverAcres,
              ActualHFRNonCarryoverAcres: actualHFRnonCarryoverAcres,
              //AllApprovedNonHFRAcres is a live number that is the contributed acres for estimated with a department approval date
              AllApprovedNonHFRAcres: allApprovedNonHFRAcres,
              //ActualNonHFRAcres is a live number that is the contributed acres for actuals with a completion date
              ActualNonHFRAcres: actualNonHFRAcres,
              BILAcres: bilAcres,
              FMRegAcres: fmRegAcres,
              FMDisasterReliefAcres: fmDisasterAcres,
            }
            index = index + 1;
            finalRows.push(obj);
            existingNames.push(estItem[FieldNames.lockedTargetFields.name]?.toLowerCase()?.trim())  
          }
        })

        const sortedFinalRows = _.cloneDeep(finalRows);
        tempSorted = sortedFinalRows.sort((a, b) => a[FieldNames.targetFields.constructedTargetAcres] > b[FieldNames.targetFields.constructedTargetAcres] ? -1 : 1);
      } 
      getGridLockedRows(tempSorted);
    }).catch(error => {
      setIsGridLoading(false);
      ErrorService.addErrorLogEntry(currentUserInfo[FieldNames.userFields.nifcUsername], error);
    });
  };

  const getGridLockedRows = (liveGridRows) => {
    setIsGridLoading(true);
    setExistingLockDate(null);
    let departmentExists = fundingDepartmentSelection && fundingDepartmentSelection[FieldNames.targetFields.filterDepartment];
    let agencyExists = fundingAgencySelection && fundingAgencySelection[FieldNames.targetFields.filterAgency];
    let regionExists = fundingRegionSelection && fundingRegionSelection[FieldNames.targetFields.filterRegion];
    let unitExists = fundingUnitSelection && fundingUnitSelection[FieldNames.targetFields.filterUnit];
    let subUnitExists = fundingSubUnitSelection && fundingSubUnitSelection[FieldNames.targetFields.filterSubUnit];
    let tribeExists = fundingTribeSelection && fundingTribeSelection[FieldNames.targetFields.filterTribe];
    
    let completedRows = [];
    TargetAccomplishmentService.getLockedEntries(
      fiscalYearSelection,
      fundingDepartmentSelection,
      fundingAgencySelection,
      fundingRegionSelection,
      fundingUnitSelection,
      fundingSubUnitSelection,
      fundingTribeSelection,
      entityTypeSelection
    ).then((lockedEntries) => {
      if (lockedEntries && lockedEntries.length > 0) {
        const firstDate = lockedEntries[0]?.CreatedOnDate;
        setExistingLockDate(firstDate);
        //tempGridRows will only have live values if they have treatments in that particular agency/region/unit/subunit/tribe
        //resp will only have values if the locked table has values.  It will be every possible combination of agency/region/unit/subunit/tribe
        //Since it has been locked, the locked values are the fuller set of values

        //How to set this up so that if the live data has more and no locked data it shows, 
        //but if the locked data has more it shows that instead. This accounts for a partial lock, no lock, or a full lock.

        lockedEntries.forEach((lockedEntry) => {
          let level = "Department";
          let existingRow = {};
          if(!departmentExists){
            level = "Department";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.department]);
          } else if(departmentExists && !agencyExists){
            level = "Agency";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.agency]);
          } else if (departmentExists && agencyExists && !regionExists) {
            level = "Region";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.region]);
          } else if (departmentExists && agencyExists && regionExists && !unitExists
          ) { 
            level = "Unit";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.unit]);
          } else if (departmentExists && agencyExists && regionExists && unitExists && lockedEntry[FieldNames.powFields.agency] === FieldNames.agencies.blm && !subUnitExists
          ) {
            level = "SubUnit";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.subUnit]);
          } else if (departmentExists && agencyExists && regionExists && unitExists && lockedEntry[FieldNames.powFields.agency] === FieldNames.agencies.bia && !tribeExists
          ) {
            level = "Tribe";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.tribe]);
          } else if (departmentExists && agencyExists && regionExists && unitExists && subUnitExists
          ) {
            level = "SubUnit";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.subUnit]);
          } else if (departmentExists && agencyExists && regionExists && unitExists && tribeExists
          ) {
            level = "Tribe";
            existingRow = liveGridRows.find((liveRow) => liveRow[FieldNames.powFields.name] === lockedEntry[FieldNames.powFields.tribe]);
          }
          
          let finalObj = {}
          if(existingRow) {
            finalObj = existingRow;
            finalObj.TargetAcres = lockedEntry[FieldNames.powFields.pOWTargetAcres];
            //Actual HFR Acres, remove Carryover acres, then divided by Target Acres)
            if(lockedEntry[FieldNames.powFields.pOWTargetAcres]){
              finalObj.TargetPercentComplete = Math.round(((existingRow[FieldNames.powFields.actualHFRAcres] - existingRow[FieldNames.powFields.actualHFRCarryoverAcres])/lockedEntry[FieldNames.powFields.pOWTargetAcres]) * 100);
            } else {
              finalObj.TargetPercentComplete = 0;
            }
            
          } else {
            
            //Come back and fix this for subunits and tribes
            finalObj = {
              ID: null,
              Name: lockedEntry[level],
              //TargetAcres is blank until locked - When locked this is a sum of all acres for the FY, exclude carryover and exclude contributed
              TargetAcres: lockedEntry[FieldNames.powFields.pOWTargetAcres],
              //TargetPercentComplete is blank until locked, excludes carryover
              TargetPercentComplete: 0,
              //AllApprovedHFRAcres is a live number and only departmentally approved, not contributed
              AllApprovedHFRAcres: 0,
              //AllPercentComplete is a percentage of acres: ActualHFRAcres/AllApprovedHFRAcres
              AllPercentComplete: 0,
              //ActualHFRAcres is a live number and only non-contributed acres and ones that have a completion date
              ActualHFRAcres: 0,
              //AllApprovedNonHFRAcres is a live number that is the contributed acres for estimated with a department approval date
              AllApprovedNonHFRAcres: 0,
              //ActualNonHFRAcres is a live number that is the contributed acres for actuals with a completion date
              ActualNonHFRAcres: 0,
              BILAcres: 0,
              FMRegAcres: 0,
              FMDisasterReliefAcres: 0,
              CarryoverAcres: 0,
              NonCarryoverAcres: 0,
            }
          }
          completedRows.push(finalObj);
        });

        let finalIndex = 0;
        let finalRows = completedRows.map((row) => {
          row.index = finalIndex;
          row.ID = finalIndex;
          finalIndex++;
          return row;
        });

        setGridRows(finalRows);
        setGraphRows(finalRows);
        setLimitedGraphRows(finalRows.slice(0, maxCountPerGraph));
        setIsGridLoading(false);
      } else {
        let finalIndex = 0;
        let finalRows = liveGridRows.map((row) => {
          row.index = finalIndex;
          row.ID = finalIndex;
          finalIndex++;
          return row;
        });
        setGridRows(finalRows);
        setGraphRows(finalRows);
        setExistingLockDate(null);
        setLimitedGraphRows(finalRows.slice(0, maxCountPerGraph));
        setIsGridLoading(false);
      }
    }).catch(error => {
      ErrorService.addErrorLogEntry(currentUserInfo[FieldNames.userFields.nifcUsername], error);
    });
    
  };

  const establishGridColumns = () => {
    let columns = [];
    const dynamicGridDef = gridRadioValue === 'All' ? allTargetManagementGridColDefinitions :
                            gridRadioValue === 'Carryover' ? carryoverTargetManagementGridColDefinitions :
                            gridRadioValue === 'Funding' ? fundingTargetManagementGridColDefinitions :
                            defaultTargetManagementGridColDefinitions;
    dynamicGridDef.forEach((colDef) => {
      let header = colDef.header;
      if(header === FieldNames.targetColumns.estimatedAcres && entityTypeSelection === FieldNames.datasets.fuels){
        header = FieldNames.targetColumns.targetAcres
      }
      const commaColumns = ["TargetAcres", "ActualAcres", "AllApprovedHFRAcres",
        "ActualHFRAcres", "AllApprovedNonHFRAcres", "ActualNonHFRAcres",
          "AllApprovedHFRCarryoverAcres", "AllApprovedHFRNonCarryoverAcres",
        "ActualHFRCarryoverAcres", "ActualHFRNonCarryoverAcres"
      ]
      columns.push({
        field: colDef.value,
        headerName: header,
        description: colDef.description,
        type: colDef.type,
        hideable: colDef.hideable,
        sortable: colDef.sortable,
        editable: colDef.editable,
        groupable: false,
        flex: colDef.flex,
        align: colDef.align,
        disableExport: colDef.disableExport,
        aggregable: (colDef.value === "TargetAcres" || colDef.value === "ActualAcres"),
        valueFormatter: (value) => {
          if(commaColumns.includes(colDef.value)
          ){
            if(colDef.value === "TargetAcres" && value === null) {
              return null;
            }
            else {
              return addCommas(value);
            }
          } else if(colDef.value === "TargetPercentComplete" || colDef.value === "AllPercentComplete") {
            if(value === null || value === undefined) {
              return null;
            } else {
              return `${value}%`;
            }
            
          } else {
            return value;
          }
        },
      });
    });

    setGridColumns(columns);
  };

  function CustomPagination({
                              page,
                              onPageChange,
                              className,
                            }) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    if (acreCounts.AcresCount > 0) {
      return (
          <>
            <Tooltip
                title={
                  <div style={{whiteSpace: 'pre-line'}}>{rowHelpText}</div>
                }
                enterDelay={100}
            >
              <HelpIcon fontSize="small" color="primary" style={{paddingLeft: 5}}/>
            </Tooltip>

            {isGridLoading ? (
                <Box sx={{
                  paddingRight: "15px !important",
                  paddingLeft: "15px !important",
                  paddingTop: "5px !important",
                  paddingBottom: "5px !important"
                }}>
                  <CircularProgress size="1.5rem"></CircularProgress>
                </Box>
            ) : (
                <MuiPagination
                    color="primary"
                    className={className}
                    count={pageCount}
                    page={page + 1}
                    onChange={(event, newPage) => {
                      onPageChange(event, newPage - 1);
                    }}
                />
            )}
          </>
      )
    } else {
      return null;
    }
  }

  function customLabelDisplayedRows( from, to, count ) { 
    return `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`; 
  }

  

  //
  // General Page Methods
  //


  // --- Grid Logic ---
  function CustomTargetGridToolbar(props) {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
        <CustomExportContainer />
      </GridToolbarContainer>
    );
  }

  function CustomExportContainer(props) {
    return (
      <GridToolbarExportContainer {...props}>
        <GridCsvExportMenuItem
          options={exportOptions}
          onClick={() => apiRef.current.exportDataAsCsv(exportOptions)}
        />
        <GridExcelExportMenuItem
          options={exportOptions}
          onClick={() => apiRef.current.exportDataAsExcel(exportOptions)}
        />
      </GridToolbarExportContainer>
    );
  }

  const exportOptions = {
    getRowsToExport: () => gridFilteredSortedRowIdsSelector(apiRef),
  };


  return (
    <Fragment>
        <InFormGenericModal
        openFlag={openProgramOfWorkDialog}
        closeMethod={() => {setOpenProgramOfWorkDialog(false)}}
        buttonMethod={(e) => {
          e.preventDefault();
          setOpenProgramOfWorkDialog(false);
          lockProgramOfWork();
        }}
        titleText={"Confirm Locking Program of Work"}
        displayButton={true}
        buttonText='Confirm'
        displayCancelButton={true}
      >
        <Box
          style={{
            maxHeight: "75vh",
            overflow: "auto",
            maxWidth: "50vw",
            minWidth: "50vw",
            marginLeft: "5px",
          }}
        >
          <Box>
            <span>Please confirm that you would like to lock the FY {fiscalYearSelection?.FiscalYear} program of work.</span>
          </Box>
          <Box sx={{whiteSpace: 'pre-wrap'}}>
            {"\n"}
          </Box>
          <Box>
          </Box>
        </Box>
      </InFormGenericModal>
        <DataGridPremium
          apiRef={apiRef}
          style={{ borderTop: 'none', height: 500}}
          getRowId={(row) => row['ID']}
          rows={gridRows}
          columns={gridColumns}
          rowsPerPageOptions={[10]}
          rowSelectionModel={selectionModel}
          pagination
          paginationMode="client"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[25]}
          showToolbar
          slots={{
            toolbar: CustomTargetGridToolbar,
            loadingOverlay: LinearProgress
          }}
          slotProps={{
            basePagination: {
              material: {
                ActionsComponent: CustomPagination,
              },
            },
          }}
          loading={isGridLoading}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          experimentalFeatures={{ aggregation: true }}
          aggregationModel={aggregationModel}
          onAggregationModelChange={(newModel) => {
            setAggregationModel(newModel);
          }}
          sx={{
            "& .MuiDataGrid-aggregationColumnHeaderLabel": {
              lineHeight: "0.25rem",
            },
          }}
        />
        <Box>
        <ThemeProvider theme={theme}>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            className={classes.snackBarStyle}
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }}
            sx={{zIndex: 9999}}
          >
            <Alert
              onClose={() => {
                setSnackbarOpen(false);
                setSnackbarMessage("");
              }}
              severity={isFailure ? "error" : "success"}
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </ThemeProvider>
      </Box>
    </Fragment>
  );
}
